import { useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

const seoData = {
  home: {
    fr: 'Chalets Gemini 1308 | Chalets de luxe \u00E0 vendre pr\u00E8s de Verbier, Suisse',
    en: 'Chalets Gemini 1308 | Luxury Chalets for Sale near Verbier, Switzerland',
  },
  portfolio: {
    fr: 'Galerie Photos | Chalets Gemini 1308 - Verbier, Suisse',
    en: 'Photo Gallery | Chalets Gemini 1308 - Verbier, Switzerland',
  },
  contact: {
    fr: 'Contact | Chalets Gemini 1308 - Demande Priv\u00E9e',
    en: 'Contact | Chalets Gemini 1308 - Private Inquiry',
  }
};

export default function SEOHead({ page = 'home' }) {
  const { lang } = useLanguage();
  const title = seoData[page]?.[lang] || seoData.home.fr;

  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
}
